/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
var $ = require( "jquery");
function IsEmail(email) {
	  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	  return regex.test(email);
}
window.IsEmail=IsEmail;
function isAllowed(text){
    var regex = /^[A-Za-z0-9#@%&\- .°*+=_!?\'()Öòàùèéì]+$/i;
    return regex.test(text);
}
function isAllowedPassword(text){
     var regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
     return regex.test(text);
}
window.isAllowedPassword = isAllowedPassword;

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
window.getCookie =getCookie ;
function checkCookie(cname) {
    var cook = getCookie(cname);
    if (cook !== "") {
        return true;
    } else {
        return false;
    }
}
window.checkCookie=checkCookie;
function setCookie(cname, cvalue, expire) {
    var d = new Date();
    d.setTime(d.getTime() + (expire));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
window.setCookie=setCookie;

function checkItemFullfill($data,$payed){
        if($data.fields){
              $("#fieldscontainer").addClass("stat1");
         }else{
              $("#fieldscontainer").removeClass("stat1");
         }
        if($data.media){
              $("#mediacontainer").addClass("stat1");
         } else{
             $("#mediacontainer").removeClass("stat1");
         }
          if($data.people){
              $("#creditscontainer").addClass("stat1");
         } else{
              $("#creditscontainer").removeClass("stat1");
         }
          if($payed){
              $("#conferma").addClass("payed");
          }else{
              $("#conferma").removeClass("payed");
          }
        if($data.media && $data.people && $data.fields && $payed){
            $("#conferma").addClass("fullfill");
             $("#confirmitem").removeClass("disabled");
            // $("#result-item").addClass("alert-success");
            // $("#result-item").removeClass("alert-warning");
            // $("#result-item").removeClass("alert-danger");
            //$("#result-item").html("<h4>FUNZIONE CONFERMA</h4>E' possibile confermare  i dati inseriti per la partecipazione");
        }else{
            $("#conferma").removeClass("fullfill");
             $("#confirmitem").addClass("disabled");
            // $("#result-item").removeClass("alert-success");
            // $("#result-item").removeClass("alert-danger");
             //$("#result-item").addClass("alert-warning");
             //$("#result-item").html(textcurtesy);
        }
}
$( document ).ready(function() {
/*popup confirm */
    $(".personcampaign input,#itemform input.required,#itemform textarea.required").each(function () {
        if ($(this).val() != '' || $(this).html() != '') {
            $(this).addClass("valid");
        } else {
            $(this).removeClass("valid");
        }
    });
$( "body").on( "click", "#confirmdecline", function() {
    $('#modal-confirm').modal('hide');
});
    function strMediaLength(){

        $(".item-upload-container .item_name span.name a").each(function(element) {

            if($(this).text().length>25){
                $(this).text($(this).text().substr(0, 20) + "...");
            }
        });
    }
    strMediaLength();

    $( window ).on("load", function() {
        // Handler for .load() called.
        $('#aidescription').keyup();
        $('#aidescription').trigger('keyup');

    });
    $( "body").on( "click",'#peoplecampaign .personcampaign .bi-chevron-up', function() {
       var e = $(this).parent().parent().parent().parent().parent();
       if(!e.is(':first-child'))
       {
       e.addClass("preselectUp");
       e.prev().addClass("preselectDown");
       $row=$(this);
       setTimeout(function() {

                e.removeClass("preselectUp");
                e.prev().removeClass("preselectDown");
                e.prev().insertAfter(e);
          }, 180);
          }
    });
    $( "body").on( "click",'#peoplecampaign .personcampaign .bi-x-circle-fill', function() {

    var e = $(this).parent().parent().parent().parent().parent();
    if(!e.is(':first-child'))
    {
           var e = $(this).parent().parent().parent().parent().parent();
           e.remove();
           }
        })
    $( "body" ).on( "click",'#peoplecampaign .personcampaign .bi-chevron-down', function() {
     var e = $(this).parent().parent().parent().parent().parent();
       if(!e.is(':last-child'))
              {
       e.addClass("preselectDown");
       e.next().addClass("preselectUp");
       $row=$(this);
       setTimeout(function() {

                e.removeClass("preselectDown");
                e.next().removeClass("preselectUp");
                e.next().insertBefore(e);
          }, 180);
          }
    })
    $( "body" ).on( "click",'#addpeople', function() {
    /*<div class="col-md-2 text-right "><label><span class="label">&nbsp;</span></label><a class="btn whitebtn" id="addpeople">Aggiungi +</a></div>*/
        if($("#peoplecampaign .personcampaign").length<=30){
        $html='<div class="row personcampaign edit"><div class="col-md-3"><label><span class="label">nome</span></label><input class="black" type="text" name="firstname" id="firstname'+$countpeople+'" required="" placeholder="Nome" value=""></div><div class="col-md-3"> <label><span class="label">cognome</span></label><input class="black" type="text" name="lastname" id="lastname'+$countpeople+'" required="" placeholder="Cognome" value=""></div><div class="col-md-4"><label><span class="label">ruolo</span></label><input class="black" type="text" name="role" id="role'+$countpeople+'" required="" placeholder="Ruolo" value=""></div><div class="col-md-1 icons"><label><span class="label">&nbsp;</span></label><div class="d-inline-block "><div class="console d-flex flex-row "><div class="d-flex flex-column border border-dark border-1 w-auto px-2 mx-2 "><i class="bi bi-chevron-up"></i><i class="bi bi-chevron-down"></i></div><div><i class="bi bi-x-circle-fill"></i></div></div></div></div></div>'
        $("#peoplecampaign").append($html);
        //$(this).remove();
        $countpeople++;
    }
});
//user
    $(".fileuploader").each(function( index ) {
        $(this).uploadFile({
            url:"/"+window.controllerid+"/uploadmedia",
            fileName:"file",
            allowedTypes:$(this).attr("data-types"),
            maxFileSize:$(this).attr("data-size"),
            showStatusAfterSuccess:false,
            formData: { pos: $(this).attr("data-id"),type:$(this).attr("data-type"), id: $itemid },
            onSuccess:function(files,data,xhr,pd)
            {
                if(data[4]=="Upload complete"){
                    $("#filename_"+data[2]+"_"+data[1]).addClass("vis");
                    $("#filename_"+data[2]+"_"+data[1]+" span.name").html("<a>"+data[3]+"</a>");
                    $("#fileuploader_"+data[2]+"_"+data[1]).css("display", "none");
                    $("#filename_"+data[2]+"_"+data[1]+" .bdelete").attr("data-mid",data[6]);
                    $("ajax-file-upload-statusbar").hide();
                    $.ajax({
                        method: "POST",
                        url: "/site/getmediaurl",
                        data: { id: data[6] }
                    }).done(function( msg ) {
                        $("#filename_"+data[2]+"_"+data[1]+" span.name a").attr("href",msg);
                        checkItemFullfill(data[8],data[9]);
                        strMediaLength();
                    });
                }else if(data[4]=="File Exixts"){
                    $("#fileuploader_"+data[2]+"_"+data[1]+" div").last().html('<div class="ajax-file-upload-error"><b>'+data[3]+'</b> File già esistente</div>');
                }else if(data[4]=="File little"){
                    $("#fileuploader_"+data[2]+"_"+data[1]+" div").last().html('<div class="ajax-file-upload-error"><b>'+data[3]+'</b> risoluzione troppo bassa</div>');
                }else if(data[4]=="Not Owner"){
                    $("#fileuploader_"+data[2]+"_"+data[1]+" div").last().html('<div class="ajax-file-upload-error"><b>'+data[3]+'</b> not owner</div>');
                }else if(data[4]=="Too many"){
                    $("#fileuploader_"+data[2]+"_"+data[1]+" div").last().html('<div class="ajax-file-upload-error"><b>'+data[3]+'</b> max '+data[2]+' achieved</div>');
                }
            },
            onError: function(files,status,errMsg,pd)
            {
                console.log(errMsg);
            }
        });
    });
    $( "body" ).on( "click",'.bdelete', function() {
        $.ajax({
            method: "POST",
            url: "/"+window.controllerid+"/deletemedia",
            data: { id: $(this).attr("data-mid"),pos: $(this).attr("data-pos") }
        }).done(function(data) {
            if(data[0]=="Deleted" && data[3]==1){
                $("#filename_"+data[1]+"_"+data[2]).removeClass("vis");
                $("#filename_"+data[1]+"_"+data[2]+" span.name").html("<a></a>");
                $("#filename_"+data[1]+"_"+data[2]+" .bdelete").attr("data-mid",0);
                $("#filename_"+data[1]+"_"+data[2]+" span.name a").attr("href","");
                if(data[1]!="url"){
                    $("#fileuploader_"+data[1]+"_"+data[2]).css("display", "block");
                    $("ajax-file-upload-statusbar").hide();
                }else{
                    $("#url_"+data[2]).css("display", "block");
                }
                checkItemFullfill(data[4],data[5]);
            }
        });
    });
    $( "body" ).on( "change keyup", ".urlcont input", function() {
        if($(this).val()!=""){
            $(this).parent().addClass("active");
        }else{
            $(this).parent().removeClass("active");
        }
    });
     $( "body" ).on( "click", ".multiple", function() {
            //$(this).addClass("selected");
            //$(this).html($(this).attr("data-selected"));
        });
    $( "body" ).on( "click ", ".urlbutton", function() {
        if($(this).parent().find("input").val()!=""){
            $.ajax({
                method: "POST",
                url: "/"+window.controllerid+"/savemedia",
                data: { filename:$(this).parent().find("input").val(),pos: $(this).attr("data-id"),type:$(this).attr("data-type"), id: $itemid },
            }).done(function( data ) {
                if(data[4]=="Upload complete"){
                    $("#filename_"+data[2]+"_"+data[1]).addClass("vis");
                    $("#filename_"+data[2]+"_"+data[1]+" span.name").html("<a>"+data[3].substr(0, 25) + "..+"+"</a>");
                    $("#filename_"+data[2]+"_"+data[1]+" .bdelete").attr("data-mid",data[6]);
                    $("#filename_"+data[2]+"_"+data[1]+" span.name a").attr("href",data[3]);
                    $("#url_"+data[1]).css("display", "none");
                    checkItemFullfill(data[8],data[9]);
                }
            });
        }
    });
    $( "body").on( "click", "#confirmconfirm", function() {
        form=$("#itemform");
        $.ajax({
            method: "POST",
            url: "/"+window.controllerid+"/updateitemfullfillstatus",
            data: {
                itemid:form.find("#itemid").val(),
            }
        }).done(function( msg ) {
            if(msg){
                $(".upditem").addClass("buttondisbled");
                $('#modal-confirm').modal('hide');
                //$("#result-item").addClass("alert-success");
                //$("#result-item").removeClass("alert-warning");
                //$("#result-item").removeClass("alert-danger");
                $("#result-item").html(textconfirm);
            }
        })
    });
    $( "body" ).on( "click", "#confirmitem", function() {
        if(!$(this).hasClass("disabled")){
            $('#modal-confirm').modal()                      // initialized with defaults
            $('#modal-confirm').modal({ keyboard: false })   // initialized with no keyboard
            $('#modal-confirm').modal('show');
        }
    });
     $( "body" ).on( "click", "#checkbest", function() {
            $(this).toggleClass("active")
            if($(this).hasClass("active")){
                $("#mention").val("|bestuseofyoutube");
            }else{
             $("#mention").val("");
            }
        });
    $( "body" ).on( "click", ".checkai", function() {
        $(".checkai").removeClass("active")
        $(this).addClass("active")
        $("#ai").val($(this).attr("data-value"));
        if($(this).attr("data-value")==1){
            $("#aicontainer").show();
        }else{
            $("#aicontainer").hide();
        }

    });

        $("textarea").on("keyup change load", function(e) {

        var characterCount = $(this).val().length,
            current = $('#current'),
            maximum = $('#maximum'),
            theCount = $('#the-count');
            current.text(characterCount);


        /*This isn't entirely necessary, just playin around*/
      /*  if (characterCount < 70) {
            current.css('color', '#666');
        }
        if (characterCount > 70 && characterCount < 90) {
            current.css('color', '#6d5555');
        }
        if (characterCount > 90 && characterCount < 100) {
            current.css('color', '#793535');
        }
        if (characterCount > 100 && characterCount < 120) {
            current.css('color', '#841c1c');
        }
        if (characterCount > 120 && characterCount < 139) {
            current.css('color', '#8f0001');
        }
*/
        if (characterCount >= 250) {
            maximum.css('color', '#8f0001');
            current.css('color', '#8f0001');
            theCount.css('font-weight','bold');
        } else {
            maximum.css('color','#666');
            theCount.css('font-weight','normal');
        }


    });
    $( "body").on( "focus", "input.black", function() {
        $(this).removeClass("error");
    });
    $( "body").on( "focus", ".personcampaign input,#itemform input.required", function() {
        $("#result-item-data").hide();
        $("#result-item-people").hide();
    });

    $( "body" ).on( "click", "#saveitem", function() {
        var form=$("#itemform");
        var peopleArr=[];
        var error=false;
        $('.personcampaign').each(function( index ) {
            if($( this ).find("[name='firstname']").val()!="" && $( this ).find("[name='lastname']").val()!="" && $( this ).find("[name='role']").val()!="" && isAllowed($( this ).find("[name='firstname']").val()) && isAllowed($( this ).find("[name='lastname']").val()) && isAllowed($( this ).find("[name='role']").val())   ){
                var myObject = new Object();
                myObject.firstname = $( this ).find("[name='firstname']").val()
                myObject.lastname = $( this ).find("[name='lastname']").val()
                myObject.role = $( this ).find("[name='role']").val()
                peopleArr.push((myObject));
            }else if($( this ).find("[name='firstname']").val()=="" && $( this ).find("[name='lastname']").val()=="" && $( this ).find("[name='role']").val()==""){
                //error=true;
                //do nothing
            }else if($( this ).find("[name='firstname']").val()=="" || $( this ).find("[name='lastname']").val()=="" || $( this ).find("[name='role']").val() =="" || !isAllowed($( this ).find("[name='firstname']").val()) || !isAllowed($( this ).find("[name='lastname']").val()) || !isAllowed($( this ).find("[name='role']").val())   ){
                /*
                $("#itemform #result").addClass("alert-danger");
                $("#itemform #result").show();
                $('#itemform input:text[value=""]').addClass("error");
                $( "#itemform #result").html('Compilare correttamente tutti i campi di ogni Credits');
                */
                error=true;
            }
        });
        if((isAllowed(form.find("#campaign").val()) || form.find("#campaign").val()=="") &&
            (isAllowed(form.find("#subject_campaign").val()) || form.find("#subject_campaign").val()=="")&&
            (isAllowed(form.find("#client_campaign").val()) || form.find("#client_campaign").val()=="")&&
            (isAllowed(form.find("#product_campaign").val()) || form.find("#product_campaign").val()=="")&&
            (isAllowed(form.find("#agenzia").val()) || form.find("#agenzia").val()=="")&&
            (isAllowed(form.find("#produzione").val()) || form.find("#produzione").val()=="")&&
            //&& ()isAllowed(form.find("#aidescription").val())
            ($("#ai").val()==0 || ($("#ai").val()==1  || form.find("#aidescription").val()=="")))
        {
            $count=0;

            if(!error) {
                $.ajax({
                    method: "POST",
                    url: "/" + window.controllerid + "/updateitem",
                    data: {
                        itemid: form.find("#itemid").val(),
                        campaign: form.find("#campaign").val(),
                        ai: form.find("#ai").val(),
                        aidescription: form.find("#aidescription").val(),
                        client_campaign: form.find("#client_campaign").val(),
                        product_campaign: form.find("#product_campaign").val(),
                        mention: form.find("#mention").val(),
                        subject_campaign: form.find("#subject_campaign").val(),
                        agenzia: form.find("#agenzia").val(),
                        produzione: form.find("#produzione").val(),
                        team_campaign: peopleArr,
                    }
                })
                    .done(function (msg) {
                        if (msg.save) {
                            $("#peoplecampaign").html("");
                            $countpeople = 0;
                            if (msg.item.team_campaign != "") {
                                $.each(jQuery.parseJSON(msg.item.team_campaign), function (i, item) {
                                    $html = '<div class="row personcampaign"><div class="col-md-3"><label><span class="label">nome</span></label><input class="black" type="text" name="firstname" id="firstname' + $countpeople + '" required="" placeholder="Nome" value="' + item.firstname + '"></div><div class="col-md-3"><label><span class="label">cognome</span></label><input class="black" type="text" name="lastname" id="lastname' + $countpeople + '" required="" placeholder="Cognome" value="' + item.lastname + '"></div><div class="col-md-4"><label><span class="label">ruolo</span></label><input class="black" type="text" name="role" id="role' + $countpeople + '" required="" placeholder="Ruolo" value="' + item.role + '"></div><div class="col-md-1 icons"><label><span class="label">&nbsp;</span></label><div class="d-inline-block "><div class="console d-flex flex-row "><div class="d-flex flex-column border border-dark border-1 w-auto px-2 mx-2 "><i class="bi bi-chevron-up"></i><i class="bi bi-chevron-down"></i></div><div><i class="bi bi-x-circle-fill"></i></div></div></div></div></div></div>'
                                    $("#peoplecampaign").append($html);
                                    $countpeople++;
                                });
                            }
                            $countpeople = 1;
                            /* <div class="col-md-3 text-right"> <label><span class="label">&nbsp;</span></label><a class="btn whitebtn" id="addpeople">Aggiungi +</a></div>*/
                            $html = '<div class="row personcampaign"><div class="col-md-3"><label><span class="label">nome</span></label><input class="black" type="text" name="firstname" id="firstname0" required="" placeholder="Nome" value=""></div><div class="col-md-3"><label><span class="label">cognome</span></label><input class="black" type="text" name="lastname" id="lastname0" required="" placeholder="Cognome" value=""></div><div class="col-md-4"><label><span class="label">ruolo</span></label><input class="black" type="text" name="role" id="role0" required="" placeholder="Ruolo" value=""></div><div class="col-md-1 icons"><label><span class="label">&nbsp;</span></label><div class="d-inline-block "><div class="console d-flex flex-row "><div class="d-flex flex-column border border-dark border-1 w-auto px-2 mx-2 "><i class="bi bi-chevron-up"></i><i class="bi bi-chevron-down"></i></div><div><i class="bi bi-x-circle-fill"></i></div></div></div></div></div></div>'
                            $("#peoplecampaign").append($html);

                            $(".personcampaign input,input.required,textarea.required").each(function () {
                                if ($(this).val() != "" || $(this).html() != "") {
                                    $(this).addClass("valid");
                                } else {
                                    $(this).removeClass("valid");
                                }

                            });
                            checkItemFullfill(msg.fullfill, msg.payed);
                            //verifico anche status dei media rispetto al prodotto e abilito il tasto conferma
                        }
                    })
            }
        }else{
            //$("#result-item").removeClass("alert-success");
            //$("#result-item").removeClass("alert-warning");
            //$("#result-item").addClass("alert-danger");
            $("#result-item-data").html("Cartteri non ammessi presenti nei dati di Campagna, Caratteri ammessi: Numeri lettere  lettere accentate <b>'.°*@#%&-+=_!?()</b>");
            $("#result-item-data").show();
            $('#itemform input.black').each(function( index,elem ) {
                if(!isAllowed($(elem).val()) && ! $(elem).val()==""){
                    $(elem).addClass("error");
                }else{
                    $(elem).removeClass("error");
                }
            });
        }
            if(error){
            // $("#result-item").removeClass("alert-success");
            // $("#result-item").removeClass("alert-danger");
            // $("#result-item").addClass("alert-danger");
            $("#result-item-people").html("Caratteri non ammessi presenti nei campi anagrafici dei Credits, Caratteri ammessi: Numeri lettere  lettere accentate <b>'.°*@#%&-+=_&!?()%</b><br/><b>Attenzione!</b> I campi Nome Cognome e Ruolo sono obbligatori");
            $("#result-item-people").show();
            $('#itemform input.black').each(function(index, elem) {
                if(!isAllowed($(elem).val()) && ! $(elem).val()==""){
                    $(elem).addClass("error");
                }else{
                    $(elem).removeClass("error");
                }
            });
        }
    });
});